var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 28",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.263 10.182c-.737 0-1.263.525-1.263 1.154v5.983c0 .63.526 1.26 1.263 1.26.737 0 1.263-.525 1.263-1.26v-5.983c0-.63-.631-1.154-1.263-1.154ZM20.737 10.181c-.632 0-1.263.525-1.263 1.26v5.983c0 .63.526 1.26 1.263 1.26.737 0 1.263-.525 1.263-1.26v-6.088c0-.63-.526-1.155-1.263-1.155ZM3.58 10.182v11.126c0 1.05.842 1.89 1.894 1.89h2v3.148c0 .63.527 1.26 1.264 1.26.736 0 1.158-.63 1.158-1.365v-3.149H12v3.15c0 .629.526 1.259 1.263 1.259.737 0 1.263-.525 1.263-1.26v-3.149h2c1.053 0 1.895-.84 1.895-1.89V10.078H3.58v.105ZM14.632 2.624 16 .105 15.684 0l-1.368 2.52c-1.053-.526-2.105-.84-3.369-.84-1.158 0-2.21.314-3.158.734L6.526 0 6.21.105l1.264 2.414c-2.21 1.26-3.79 3.674-3.79 6.403h14.737c-.105-2.73-1.579-5.038-3.79-6.298ZM7.263 6.088a.718.718 0 0 1-.737-.735c0-.42.316-.63.737-.63s.737.315.737.63c-.105.42-.421.735-.737.735Zm7.369 0a.719.719 0 0 1-.737-.735c0-.42.316-.63.737-.63.42 0 .737.315.737.63 0 .42-.316.735-.737.735Z"
  })));
};

export default SvgAndroid;